import LegalLayout, { H2, P, UL } from "@/components/legal/LegalLayout";

export default function RiskPage() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Risk Disclosure"
      updated="January 20, 2026"
      testid="risk-page"
    >
      <P>
        Qovarix provides access to high-frequency, AI-powered prediction markets operating on the
        Base blockchain. Trading prediction markets involves substantial risk, including the
        possible loss of all funds committed. This disclosure summarizes key risks. It is not
        exhaustive. Before participating, you should carefully evaluate whether the Service is
        suitable for you.
      </P>

      <H2>1. Risk of Total Loss</H2>
      <P>
        Prediction market outcomes are binary or probabilistic. You may lose the entire amount of
        any position you take. Past performance of markets, strategies, or the Qovarix AI engine is
        not indicative of future results.
      </P>

      <H2>2. Volatility and Speed</H2>
      <P>
        Qovarix is designed for sub-second settlement on short-horizon markets. Prices and
        probabilities can move rapidly. Slippage, adverse selection, and latency risk may materially
        affect outcomes.
      </P>

      <H2>3. Smart Contract Risk</H2>
      <UL>
        <li>Smart contracts may contain undiscovered bugs, economic exploits, or design flaws.</li>
        <li>Audits reduce but do not eliminate risk.</li>
        <li>Upgrades, governance actions, or emergency pauses may impact open positions.</li>
      </UL>

      <H2>4. Blockchain Risk</H2>
      <P>
        The Base network, its sequencer, bridges, and underlying Ethereum settlement are
        independent of Qovarix and subject to congestion, reorgs, downtime, and economic events that
        may affect the Service.
      </P>

      <H2>5. Oracle and Data Risk</H2>
      <P>
        Market resolution may rely on oracles and off-chain data providers. Manipulated, delayed, or
        incorrect feeds may cause incorrect resolutions. While Qovarix applies multiple safeguards,
        oracle risk cannot be fully eliminated.
      </P>

      <H2>6. Regulatory Risk</H2>
      <P>
        The legal treatment of prediction markets and decentralized finance varies by jurisdiction
        and is evolving. Access may be restricted, and you are solely responsible for complying with
        applicable laws.
      </P>

      <H2>7. AI Engine Risk</H2>
      <P>
        The Qovarix Market Engine uses AI signals to set and adjust probabilities. AI outputs are
        probabilistic estimates, not guarantees. Models can misread conditions, especially during
        unprecedented events or thin liquidity.
      </P>

      <H2>8. Non-Custodial Responsibility</H2>
      <P>
        You retain custody of your wallet and private keys. Loss of keys, phishing, malware, or
        signing malicious transactions can result in irreversible loss of funds. Qovarix cannot
        recover lost keys or reverse transactions.
      </P>

      <H2>9. No Advice</H2>
      <P>
        Nothing on Qovarix is investment, legal, or tax advice. You should consult qualified
        professionals before participating.
      </P>

      <P className="text-slate-400">
        By using Qovarix, you acknowledge that you have read, understood, and accepted these risks.
      </P>
    </LegalLayout>
  );
}
